<template>
  <v-container fluid>
    <v-progress-linear
      color="primary"
      :height="7"
      :active="isLoading"
      indeterminate
      style="position: fixed; top: 153px; left: 0; width: 100%; z-index: 10"
    />
    <v-row>
      <v-col>
        <BannerAlertVue
          v-if="!siteSystems.length && !isLoading"
          :message="bannerMessage"
        />
        <v-row>
          <v-col>
            <SiteSystemsBar />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <SiteSystemsList />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';

import SiteSystemsBar from '@/Core.Service.Domain/Sites/SiteSystems/Components/SiteSystemsBar.vue';
import SiteSystemsList from '@/Core.Service.Domain/Sites/SiteSystems/Components/SiteSystemsList.vue';
import BannerAlertVue from '@/Core.UI.Domain/Components/BannerAlert.vue';

const store = useStore();

const siteSystems = computed(() => store.getters['SitesStore/SiteSystemsStore/siteSystems']);
const isLoading = computed(
  () => store.getters['SitesStore/SiteSystemsStore/isSiteSystemsLoading']
);
const bannerMessage = 'No Site Systems configured for this site';
</script>
